import axios from 'axios'

export function getPreviousReview (productId) {
  return new Promise((resolve, reject) => {
    axios.get(`/?fc=module&module=dbs_productsreviews&controller=api&action=getReview&product=${productId}`)
      .then(response => resolve(response.data && response.data.success ? response.data : null))
      .catch(reject)
  })
}



// WEBPACK FOOTER //
// ./src/api/productReviews/getPreviousReview.js